import { jsx as _jsx } from "react/jsx-runtime";
const CLASSE = {
    poligono: 'amostra',
    linha: 'amostra amostra--linha',
    ponto: 'amostra amostra--ponto',
};
/** Amostra de simbologia usada no controle de camadas e na legenda. */
export function Amostra({ cor, familia }) {
    const estilo = {
        '--traco': cor,
        '--preenchimento': `color-mix(in srgb, ${cor} 18%, transparent)`,
        '--estilo-traco': 'solid',
    };
    return _jsx("span", { className: CLASSE[familia], style: estilo, "aria-hidden": "true" });
}
